export const getIsPersistStorageHydrated = (state: RootState): boolean =>
    state.core.storageConfig.isPersistStorageStoreHydrated;
